<template>
<div class="table-responsive">
  <v-simple-table mobile-breakpoint="0" class="table-balance-company">
    <template v-slot:default>
      <thead>
        <tr>
          <th>{{ $t("page.profile.date") }}</th>
          <th>{{$t('page.profile.description')}}</th>
          <th>{{$t('page.profile.debit')}}</th>
          <th>{{$t('page.profile.credit')}}</th>
          <th>{{$t('page.profile.balance')}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.date">
          <td valign="top" class="pt-2">{{ item.date }}</td>
          <td valign="top" class="pt-2">{{ item.description }}</td>
          <td valign="top" class="pt-2">{{ formater(item.debit) }}</td>
          <td valign="top" class="pt-2">{{ formater(item.credit) }}</td>
          <td valign="top" class="pt-2">{{ formater(item.balance) }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          date: "10-JAN-2022",
          description: "ACCOUNT STATEMENT BATCH 12345 1-DEC-2021 – 31-DEC-2021",
          debit: 25000000,
          credit: 0,
          balance: 25000000,
        },
        {
          date: "10-FEB-2022",
          description: "ACCOUNT STATEMENT BATCH 12345 1-JAN-2022 – 31-JAN-2022",
          debit: 55000000,
          credit: 0,
          balance: 85000000,
        },
        {
          date: "15-FEB-2022",
          description: "PAYMENT VIA BCA VIRTUAL ACCOUNT",
          debit: 0,
          credit: 25000000,
          balance: 55000000,
        },
        {
          date: "26-FEB-2022",
          description: "PAYMENT VIA BCA VIRTUAL ACCOUNT",
          debit: 0,
          credit: 55000000,
          balance: 0,
        },
        {
          date: "10-MAR-2022",
          description: "ACCOUNT STATEMENT BATCH 12345 1-FEB-2022 – 31-FEB-2022",
          debit: 125000000,
          credit: 0,
          balance: 125000000,
        },
      ],
    };
  },
  methods:{
    formater(value) {
      let angka = parseInt(value) || 0;
      let nilai = angka.toLocaleString("en-US", { minimumFractionDigits: 2 });
      return nilai;
    },
  }
};
</script>
<style>
.table-balance-company thead {
      background: #ddd !important;
      font-weight: bold;
      color: #000 !important;
  }
  .table-balance-company thead tr th{
      height: 38px !important;
  }
  .table-balance-company tbody tr td{
      font-size: 12px !important;
      height: 35px !important;
  }
  .table-balance-company tbody tr:hover{
      background-color: transparent !important;
  }
</style>
